import { Link } from "react-router-dom";
import styles from "./ClosingSection.module.css";
import mapImage from "../assets/34068_Karte Neu_Ausschitt_pfade.png";
import IconsFertigung from "../assets/Icons_Fertigung.svg";
import IconsProduktvielfalt from "../assets/Icons_Produktvielfalt.svg";
import { DiagonalLabel } from "./DiagonalLabel";

const closingTextBlocks = [
  {
    title: (
      <>
        MODERNSTE
        <br />
        FERTIGUNGS&shy;TECHNOLOGIE
      </>
    ),
    Icon: IconsFertigung,
    items: [
      "Schneiden",
      "Lasern",
      "Biegen",
      "Pressen",
      "Schweißen",
      "Beschichten",
      "Manuell und computergestützt",
    ],
  },
  {
    title: (
      <>
        BREITE
        <br />
        PRODUKT&shy;PALETTE
      </>
    ),
    Icon: IconsProduktvielfalt,
    items: [
      "Behälter",
      "Kästen",
      "Gestelle",
      "Paletten",
      "Ladungsträger",
      "Rammschutzprofile",
      "Kantteile oder Hartkunststoff-Zuschnitte nach Maß",
      "Individuelle Stahl-Lösungen",
      "Als Einzelstück, Klein- oder Großserie",
    ],
  },
];

export default function ClosingSection() {
  return (
    <section className={styles.closingSection} aria-label="Abschlussbereich">
      <div className={styles.contentLayer}>
        <div className={styles.greenTagArea}>
          <p>
            Geballte Stahl-Kompetenz – das ist bei uns der entscheidende Faktor.
            Damit sorgen wir für ein Produkt, das stabiler, langlebiger und
            nachhaltiger ist – ökologisch und wirtschaftlich.
          </p>
          <div className={styles.labelWrapper}>
            <DiagonalLabel
              text={
                <>
                  Melanie Brücher-Kümmel
                  <br />
                  Geschäftsführerin
                </>
              }
            />
          </div>
        </div>

        <div className={styles.dualTextBlocks}>
          {closingTextBlocks.map((block) => (
            <article key={block.items[0]} className={styles.iconTextBlock}>
              <div className={styles.iconHeader}>
                <img src={block.Icon} alt="" />
                <h3>{block.title}</h3>
              </div>
              <ul>
                {block.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        <div className={styles.familySection}>
          <h3>STAHLEXPERTISE TRIFFT AUF FAMILIENUNTERNEHMEN</h3>
          <p>
            stahlfaktor – das ist ein Team aus Maschinenbau-Ingenieur:innen und
            Wirtschafts&shy;wissen&shy;schaftler:innen um Familie
            Brücher-Kümmel. Intensiver Austausch, intern wie extern, ist bei uns
            selbstverständlich. Wir beraten Sie mit unserem fundierten
            technischen Know-how. Individuell und kompetent – gerne auch bei
            Ihnen vor Ort. Ihr Anliegen ist bei uns Chefsache.
          </p>
          <div className={styles.citationBlock}>
            <p className={styles.citation}>
              WIR FREUEN UNS DARAUF, SIE UND IHRE PROJEKTE KENNENZULERNEN.
            </p>
            <div className={styles.citationLabel}>
              <DiagonalLabel />
            </div>
          </div>
        </div>
      </div>

      <img
        src={mapImage}
        alt=""
        aria-hidden="true"
        className={styles.mapGraphic}
      />

      <footer className={styles.footerLinks}>
        <Link to="/impressum">
          <span>Impressum</span>
        </Link>
        <Link to="/datenschutz">
          <span>Datenschutz</span>
        </Link>
      </footer>
    </section>
  );
}
